import React from 'react';
import { useNavigate } from 'react-router-dom';

const MentionsLegalesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950 text-amber-50 p-6">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-4 mb-8">
          <button
            onClick={() => navigate(-1)}
            className="bg-slate-800/60 border border-white/10 hover:border-amber-500/30 text-amber-50 px-4 py-2 rounded-full transition-all text-sm"
          >
            ← Retour
          </button>
          <h1 className="text-2xl font-bold text-amber-400">Mentions légales</h1>
        </div>

        <div className="bg-slate-800/60 border border-white/10 rounded-2xl p-6 space-y-6 text-slate-300 leading-relaxed">

          <p className="text-slate-400 text-sm">Dernière mise à jour : mars 2026</p>

          <section>
            <h2 className="text-lg font-semibold text-amber-300 mb-2">1. Éditeur de l'application</h2>
            <p>
              <strong className="text-amber-50">Cyril Tronchet</strong><br />
              Professeur de batterie indépendant<br />
              Contact : <a href="mailto:musicjob1975@gmail.com" className="text-amber-400 hover:underline">musicjob1975@gmail.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-amber-300 mb-2">2. Hébergement</h2>
            <p>
              L'application est hébergée par :<br />
              <strong className="text-amber-50">Google LLC</strong> — Firebase Hosting<br />
              1600 Amphitheatre Parkway, Mountain View, CA 94043, États-Unis<br />
              <a href="https://firebase.google.com" target="_blank" rel="noreferrer" className="text-amber-400 hover:underline">firebase.google.com</a>
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-amber-300 mb-2">3. Propriété intellectuelle</h2>
            <p>
              L'ensemble du contenu de cette application (textes, exercices, notations musicales, code source) est la propriété exclusive de Cyril Tronchet, sauf mention contraire. Toute reproduction, distribution ou utilisation sans autorisation est interdite.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-amber-300 mb-2">4. Données personnelles</h2>
            <p>
              Le traitement des données personnelles est décrit dans notre{' '}
              <button
                onClick={() => navigate('/politique-confidentialite')}
                className="text-amber-400 hover:underline"
              >
                Politique de confidentialité
              </button>.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-amber-300 mb-2">5. Responsabilité</h2>
            <p>
              L'éditeur s'efforce de maintenir l'application accessible et fonctionnelle, mais ne peut garantir une disponibilité continue. L'éditeur ne saurait être tenu responsable des dommages directs ou indirects liés à l'utilisation de l'application.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-amber-300 mb-2">6. Droit applicable</h2>
            <p>
              Les présentes mentions légales sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default MentionsLegalesPage;
